import { MenuItem } from "@chakra-ui/react";
import { useState } from "react";
import { FormattedMessage } from "react-intl";

import { ApiKeyRead } from "@nens/rana/api-v1";
import { SettingsIcon } from "@nens/ranalib";

import { PublicationDetailShareList } from "./components/share-list";
import { PublicationDetailShareRevoke } from "./components/share-revoke";
import { PublicationDetailShareEdit } from "./share-create-or-edit";

type OpenModal =
  | {
      type: "share-list";
    }
  | {
      type: "share-details" | "share-revoke";
      share: ApiKeyRead;
    };

export function PublicationDetailFileShare() {
  const [openModal, setOpenModal] = useState<OpenModal | null>(null);
  const onClose = () => setOpenModal(null);
  const toList = () => setOpenModal({ type: "share-list" });

  return (
    <>
      <MenuItem onClick={toList} icon={<SettingsIcon />}>
        <FormattedMessage id="button.manage_shares" defaultMessage="Manage shares" />
      </MenuItem>

      {openModal?.type === "share-list" ? (
        <PublicationDetailShareList
          onClose={onClose}
          setSelectedShare={(share) => setOpenModal({ type: "share-details", share })}
        />
      ) : null}
      {openModal?.type === "share-details" ? (
        <PublicationDetailShareEdit
          onClose={onClose}
          share={openModal.share}
          back={toList}
          setRevokeShare={() => setOpenModal({ type: "share-revoke", share: openModal.share })}
        />
      ) : null}
      {openModal?.type === "share-revoke" ? (
        <PublicationDetailShareRevoke
          onClose={onClose}
          share={openModal.share}
          toList={toList}
          back={() => setOpenModal({ type: "share-details", share: openModal.share })}
        />
      ) : null}
    </>
  );
}
